var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturesIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.33 47.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#594cda;}.cls-2{fill:#eb427e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "features-icon-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.852,3.324V27.478H44.005A22.058,22.058,0,1,1,19.852,3.324Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.264,0A25.371,25.371,0,0,1,47.33,23.066H24.264V0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesIcon2);
export default __webpack_public_path__ + "static/media/features-icon-2.db5a8dac8eb5e1785923ceeb4e9d83a7.svg";
export { ForwardRef as ReactComponent };